import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
export type MaterialGraphRevisionFragment = { __typename: 'MaterialRevision', id: string, legacyId: number, material: { __typename: 'Material', name?: string | null, legacyId: number } };

export type MaterialGraphExtendedRevisionFragment = { __typename: 'MaterialRevision', graphNode: any, id: string, legacyId: number, material: { __typename: 'Material', name?: string | null, legacyId: number } };

export type LatestMaterialGraphExtendedFragment = { __typename: 'Material', id: string, legacyId: number, latestCyclesRevision?: { __typename: 'MaterialRevision', graphNode: any, id: string, legacyId: number, material: { __typename: 'Material', name?: string | null, legacyId: number } } | null };

export const MaterialGraphRevisionFragmentDoc = gql`
    fragment MaterialGraphRevision on MaterialRevision {
  id
  legacyId
  material {
    name
    legacyId
  }
}
    `;
export const MaterialGraphExtendedRevisionFragmentDoc = gql`
    fragment MaterialGraphExtendedRevision on MaterialRevision {
  ...MaterialGraphRevision
  graphNode
}
    `;
export const LatestMaterialGraphExtendedFragmentDoc = gql`
    fragment LatestMaterialGraphExtended on Material {
  id
  legacyId
  latestCyclesRevision {
    ...MaterialGraphExtendedRevision
  }
}
    `;